// Сина — trigger: «Когда твой юнит идёт в сброс: +1 Влияния».
// Срабатывает на любую смерть юнита у владельца, у которого Герой = Сина.

import { addInfluence } from './influence.js';

export const HERO_ID = 'deus_sina';

// ownerIdx — владелец погибшего юнита; card — погибшая карта (для проверки sleeperState).
// А.4.4.4-fix1: смерть Спящего агента у врага (sleeperState != null) НЕ триггерит Сину.
export function sinaOnUnitDied(state, ownerIdx, card) {
  if (card?.sleeperState != null) return;
  const p = state.players[ownerIdx];
  if (!p || p.hero.id !== HERO_ID) return;
  addInfluence(state, ownerIdx, 1, 'Сина [юнит в сброс]');
}
